import React, { createContext, useState, useContext, useCallback, useMemo } from 'react';

// Create a context to provide dynamic component for Topbar
const TopbarContext = createContext();

// Custom hook to access the context
export const useTopbar = () => {
  const context = useContext(TopbarContext);
  if (!context) {
    throw new Error('useTopbar must be used within a TopbarProvider');
  }
  return context;
};

// TopbarProvider component to provide the context
export const TopbarProvider = ({ children }) => {
  const [extraComponent, setExtraComponent] = useState(null);
  const [title, setTitle] = useState(null);

  // Stable function refs so consumers can safely list these in useEffect deps
  // without retriggering on every provider re-render (which the setters cause).
  const showExtraComponent = useCallback((component) => setExtraComponent(component), []);
  const clearExtraComponent = useCallback(() => setExtraComponent(null), []);
  const showExtraTitle = useCallback((component) => setTitle(component), []);
  const clearExtraTitle = useCallback(() => setTitle(null), []);

  const value = useMemo(
    () => ({ extraComponent, showExtraComponent, clearExtraComponent, title, showExtraTitle, clearExtraTitle }),
    [extraComponent, title, showExtraComponent, clearExtraComponent, showExtraTitle, clearExtraTitle],
  );

  return (
    <TopbarContext.Provider value={value}>
      {children}
    </TopbarContext.Provider>
  );
};
